<template>
  <div>
    <el-row>
      <el-col :span="24">
        <div class="grid-content">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>批次模块</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: 'batchListProgress' }">批次进度</el-breadcrumb-item>
            <el-breadcrumb-item>批次统计</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20"
            class="grid-content">
      <el-col :span="12">
        <div>
          批次名称：
          <span>{{batch.title}}</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div>{{batch.state}}</div>
      </el-col>
      <el-col :span="6">
        <el-button v-if="batch.progress==1"
                   type="primary"
                   size="small"
                   class="widthButton"
                   @click="end">结束</el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20"
            class="grid-content">
      <el-col :span="5">
        <div>
          总件数：
          <span>{{batch.total}}</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div>
          工序数量：
          <span>{{batch.processCount}}</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div>
          单件成本：
          <span>{{batch.laborcost}}（元）</span>
        </div>
      </el-col>
      <el-col :span="5">
        <div>
          人工成本:
          <span>{{batch.totalLaborcost}}（元）</span>
        </div>
      </el-col>
      <!-- <el-col :span="4">
        <div>
          已完成件数：
          <span>{{batch.totalSalary}}</span>
        </div>
      </el-col>-->
    </el-row>

    <div class="inputDiv">
      <div>
        工序名称：
        <el-input v-model="name"
                  class="inputLeft"
                  style="width: unset;"
                  placeholder="请输入工序名称"></el-input>
      </div>

      <el-button type="primary"
                 class="widthButton"
                 @click="handleCurrentChange(1)">查询</el-button>

      <el-button type="primary"
                 v-if="batch.progress!=0"
                 class="widthButton"
                 @click="exportBatchWorkWorkRecord">统计汇总导出</el-button>
    </div>

    <el-table :data="tableData"
              border
              class="grid-content"
              :row-class-name="tableRowClassName"
              @row-click="goProcessDetails"
              style="width: 95%;">
      <el-table-column fixed
                       prop="name"
                       label="工序名称"></el-table-column>
      <el-table-column prop="unitSalary"
                       label="单价（元）"></el-table-column>
      <el-table-column prop="total"
                       label="总件数"></el-table-column>
      <el-table-column prop="procedureTotal"
                       label="总价（元）"></el-table-column>
      <el-table-column prop="completed"
                       label="已完成(件)"></el-table-column>
      <el-table-column prop="endPrice"
                       label="已完成工价(元)"></el-table-column>
      <el-table-column prop="percents"
                       label="工作进度"></el-table-column>
      <el-table-column prop="state"
                       label="核查状态"></el-table-column>
    </el-table>
    <el-pagination class="grid-content"
                   background
                   @current-change="handleCurrentChange"
                   layout="total, prev, pager, next"
                   :total="totalCount"
                   :page-size="pageSize"
                   :page-count="pageTotal"></el-pagination>
    <div class="inputDiv">
      <el-button class="widthButton"
                 @click="goback">取消</el-button>
    </div>
  </div>
</template>
<script>
import { processSel, batchSel, batchComplete } from "@/api/batch";
import { getBatchStates } from "@/util/enum";
import {
  workRecordExportBatchWork
} from "@/api/workRecord";
export default {
  data () {
    return {
      batch: {},
      totalCount: 0,
      pageSize: 10,
      pageNum: 1,
      pageTotal: 0,
      tableData: [],
      name: ""
    };
  },
  mounted () {
    this.batch = this.$route.query;
    this.getBatchInfo();
  },
  methods: {
    tableRowClassName ({ row }) {
      if (row.percent > 100) {
        return "Danger-row";
      } else if (row.percent < 100) {
        return "warning-row";
      } else if (row.percent == 100) {
        return "success-row";
      }
    },
    getProcessSel () {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        batchId: this.batch.id,
        name: this.name,
        orderBy: 'percent',
        pageNum: this.pageNum,
        pageSize: this.pageSize
      };
      processSel(params)
        .then(res => {
          this.totalCount = res.page.total_count;
          this.pageTotal = res.page.page_total;
          this.tableData = [];
          res.gridData.forEach(element => {
            element.procedureTotal = (
              this.batch.total * element.unitSalary
            ).toFixed(4);
            element.total = this.batch.total;
            (element.completed = element.completed ? element.completed : 0),
              (element.endPrice = (
                element.completed * element.unitSalary
              ).toFixed(4));
            if (element.percent > 100) {
              element.state = "已超出";
            } else if (element.percent == 100) {
              element.state = "已完成";
            } else {
              element.state = "未完成";
            }
            element.percents = element.percent + "%";
            this.tableData.push(element);
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    goProcessDetails (row) {
      this.$router.push({
        path: "processdetails",
        query: { id: row.id, batchId: this.batch.id }
      });
    },
    handleCurrentChange (e) {
      this.pageNum = e;
      this.getProcessSel();
    },
    goback () {
      this.$router.go(-1);
    },
    end () {
      if (this.batch.checkState == 0) {
        this.$message({
          type: "error",
          message: "请先确认工序才能结束！"
        });
        return;
      }
      this.$confirm("批次结束后将不能再上报此批次的工作， 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          batchComplete({ id: this.batch.id })
            .then(() => {
              this.$message({
                type: "success",
                message: "结束成功!"
              });
              this.goback();
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => { });
    },
    getBatchInfo () {
      const params = {
        enterpriseId: localStorage.getItem("company_id"),
        id: this.batch.id
      };
      batchSel(params)
        .then(res => {
          this.batch = res.gridData[0];
          this.batch.state = getBatchStates(this.batch.progress);
          this.handleCurrentChange(1);
        })
        .catch();
    },
    exportBatchWorkWorkRecord () {
      const params = {
        userId: localStorage.getItem("user_id"),
        batchId: this.batch.id
      };
      workRecordExportBatchWork(params, this.batch.title + "  汇总表");
    }
  }
};
</script>
<style>
.el-table .Danger-row {
  background: rgb(253, 107, 107);
}
.el-table .warning-row {
  background: rgb(247, 194, 97);
}

.el-table .success-row {
  background: rgb(79, 255, 79);
}
</style>
